import { c as _c } from "react/compiler-runtime";
import { Box, LinearProgress, Typography } from "@mui/material";
import { useAppSelector } from "#/store/hooks";

/**
 * Snackbar body that shows live benchmark progress from Redux state
 * (updated by the worker benchmark-progress messages via benchmarkSlice).
 */
export const BenchmarkProgressSnackbarContent: React.FC = () => {
  const $ = _c(10);
  const progress = useAppSelector(_temp) ?? {
    current: 0,
    total: 1
  };
  const value = progress.total > 0 ? Math.min(100, Math.max(0, progress.current / progress.total * 100)) : 0;
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      minWidth: 220
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== progress.current || $[2] !== progress.total) {
    t1 = <Typography variant="body2">Benchmark: {progress.current} / {progress.total} iterations</Typography>;
    $[1] = progress.current;
    $[2] = progress.total;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      mt: 1,
      "& .MuiLinearProgress-bar": {
        transition: "none"
      }
    };
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== value) {
    t3 = <LinearProgress variant="determinate" color="success" value={value} sx={t2} />;
    $[5] = value;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t1 || $[8] !== t3) {
    t4 = <Box sx={t0}>{t1}{t3}</Box>;
    $[7] = t1;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
};
function _temp(state) {
  return state.benchmark.progress;
}